import { type User } from "@internal/user";
import { formatMetric } from "@north-beam/nb-common/formatting";
import { type MetricPrecision } from "@north-beam/nb-common/formatting";

import { type Kpi } from "../components/explore-budgets/client-setting/types";

export const efficiencyKpiManager = (kpi: Kpi | undefined, user: User) => {
  const type = kpi?.kpi_type;
  const kpiFormat = type === "price_value" ? "dollars" : "decimal";

  const kpiFormatter = (
    value: number,
    precision: MetricPrecision = "approximate",
  ) =>
    formatMetric(value, kpiFormat, {
      precision,
      code: user.currencies.currentCurrency,
    });

  const efficiencyKpiType = kpiFormat === "dollars" ? "ROAS" : "CAC";

  const efficiencyKpiFormatter = (
    value: number,
    precision: MetricPrecision = "approximate",
  ) => {
    const format = efficiencyKpiType === "ROAS" ? "multiplier" : "dollars";
    return formatMetric(value, format, {
      precision,
      code: user.currencies.currentCurrency,
    });
  };

  const efficiencyKpiCalculator = (spend: number, kpiValue: number) => {
    if (efficiencyKpiType === "ROAS") {
      return kpiValue / spend;
    } else {
      return spend / kpiValue;
    }
  };

  return {
    kpiFormat,
    kpiFormatter,
    efficiencyKpiType,
    efficiencyKpiFormatter,
    efficiencyKpiCalculator,
  } as const;
};
